// Bilingual translations (中文 / English)
// Use t(key) where key is dotted path, returns string in selected language

export const translations = {
  // Common
  app_name: { zh: '你和我 哺乳教练', en: 'You & Me Lactation Coach' },
  back: { zh: '返回', en: 'Back' },
  next: { zh: '下一步', en: 'Next' },
  submit: { zh: '提交', en: 'Submit' },
  cancel: { zh: '取消', en: 'Cancel' },
  save: { zh: '保存', en: 'Save' },
  loading: { zh: '加载中...', en: 'Loading...' },
  start_over: { zh: '重新开始', en: 'Start Over' },
  optional: { zh: '可选', en: 'Optional' },
  yes: { zh: '是', en: 'Yes' },
  no: { zh: '否', en: 'No' },

  // Header / Nav
  nav_home: { zh: '首页', en: 'Home' },
  nav_self_check: { zh: '自我检测', en: 'Self-check' },
  nav_milk_log: { zh: '奶量记录', en: 'Milk Log' },
  nav_consultants: { zh: '泌乳顾问', en: 'Consultants' },
  nav_booking: { zh: '预约咨询', en: 'Book' },
  nav_admin: { zh: '管理', en: 'Admin' },
  nav_library: { zh: '资料库', en: 'Library' },
  nav_about: { zh: '关于我们', en: 'About Us' },
  nav_menu: { zh: '菜单', en: 'Menu' },
  nav_privacy: { zh: '隐私政策', en: 'Privacy' },
  nav_terms: { zh: '服务条款', en: 'Terms' },

  // Landing extra sections
  landing_free_help_title: { zh: '预约前，你也可以先得到帮助', en: 'Get Helpful Guidance Before Booking' },
  landing_free_help_body: {
    zh: '完成 Self-check 后，系统会根据你的情况提供初步解释、处理步骤和相关教学资源，例如手挤奶、Epsom salt 浸泡、亲喂姿势或挤奶器喇叭尺寸检查。',
    en: 'After completing the self-check, you will receive an initial explanation, practical next steps, and related teaching resources such as hand expression, Epsom salt soaking, latch positioning, or flange fit check.',
  },
  landing_founder_short: {
    zh: '由 Soo Li Theng 创办，政府认证护士、国家认证讲师、泌乳辅导员，拥有 15 年护理经验，并与雪隆区 10 家以上月子中心合作。',
    en: 'Founded by Soo Li Theng, registered nurse, certified trainer, and lactation peer counsellor with 15 years of nursing experience and collaborations with 10+ confinement centres across KL/Selangor.',
  },
  landing_about_btn: { zh: '了解我们', en: 'About Us' },
  landing_library_preview_title: { zh: '免费教学资源', en: 'Featured Resources' },
  landing_library_browse: { zh: '浏览资料库', en: 'Browse Library' },

  // Result page additions
  result_related_library: { zh: '资料库相关资源', en: 'Related Library Resources' },

  // Admin tabs
  admin_tab_cases: { zh: '案例', en: 'Cases' },
  admin_tab_library: { zh: '资料库管理', en: 'Library Manager' },
  admin_tab_company: { zh: '公司内容', en: 'Company Content' },
  admin_placeholder_msg: {
    zh: '此功能 MVP 中暂以占位形式呈现，后续可加入真实媒体上传与编辑。',
    en: 'This feature is shown as placeholder for the MVP. Real media upload and editing can be added later.',
  },
  admin_lib_add: { zh: '新增资源（占位）', en: 'Add resource (placeholder)' },
  admin_lib_upload: { zh: '上传媒体（占位）', en: 'Upload media (placeholder)' },
  admin_lib_intro: {
    zh: '编辑标题、分类、简介和媒体 URL（YouTube / Vimeo / mp4 / 图片）。改动会立即反映在公开资料库。',
    en: 'Edit titles, category, description, and media URL (YouTube / Vimeo / mp4 / image). Changes appear instantly in the public library.',
  },
  admin_lib_edit: { zh: '编辑', en: 'Edit' },
  admin_lib_has_media: { zh: '有媒体', en: 'Has media' },
  admin_lib_no_media: { zh: '未设置媒体', en: 'No media' },
  admin_company_edit_about: { zh: '编辑关于我们（占位）', en: 'Edit About sections (placeholder)' },
  admin_company_manage_logos: { zh: '管理合作 logo（占位）', en: 'Manage collaboration logos (placeholder)' },
  admin_company_manage_gallery: { zh: '管理媒体画廊（占位）', en: 'Manage media gallery (placeholder)' },

  // Mother profile (lightweight beta auth)
  profile_create_title: { zh: '创建妈妈档案', en: 'Create Mother Profile' },
  profile_create_subtitle: {
    zh: '保存你的资料，未来回来时可以看到之前的 self-check 和奶量记录。',
    en: 'Save your details so you can return later to view your past self-checks and milk logs.',
  },
  profile_login_title: { zh: '继续之前的档案', en: 'Continue with your profile' },
  profile_login_subtitle: {
    zh: '使用 WhatsApp 电话号码、宝宝生日（如有设置 PIN 请输入）登入。',
    en: 'Sign in using your WhatsApp phone, baby birth date and PIN (if you set one).',
  },
  profile_name: { zh: '妈妈姓名', en: 'Mother name' },
  profile_phone: { zh: 'WhatsApp 电话号码', en: 'WhatsApp phone' },
  profile_phone_hint: { zh: '例如：+60 12 345 6789', en: 'e.g. +60 12 345 6789' },
  profile_baby_dob: { zh: '宝宝生日', en: 'Baby birth date' },
  profile_dob_hint: { zh: '推荐：使用宝宝出生日期', en: 'Recommended: use baby birth date' },
  profile_pin: { zh: 'PIN（4-6 数字，选填）', en: 'PIN (4–6 digits, optional)' },
  profile_pin_hint: { zh: '设置 PIN 可以在共用手机时更安全', en: 'Adding a PIN keeps your record safer on shared phones' },
  profile_consent: {
    zh: '我同意 You & Me Lactation Coach 保存我的资料、self-check 记录和奶量记录，以便提供哺乳支持。我明白此工具不取代医生诊断。',
    en: 'I agree that You & Me Lactation Coach may store my profile, self-check records, and milk logs to provide breastfeeding support. I understand this tool does not replace medical diagnosis.',
  },
  profile_create_btn: { zh: '创建档案', en: 'Create profile' },
  profile_login_btn: { zh: '继续', en: 'Continue' },
  profile_have_account: { zh: '已经有档案？', en: 'Already have a profile?' },
  profile_no_account: { zh: '还没有档案？', en: 'No profile yet?' },
  profile_login_link: { zh: '登入', en: 'Log in' },
  profile_register_link: { zh: '创建', en: 'Create one' },
  profile_logout: { zh: '退出', en: 'Log out' },
  profile_dashboard_title: { zh: '我的档案', en: 'My Profile' },
  profile_total_selfchecks: { zh: 'Self-check 总数', en: 'Total self-checks' },
  profile_latest_risk: { zh: '最近风险等级', en: 'Latest risk level' },
  profile_today_total: { zh: '今天总奶量', en: 'Today total milk' },
  profile_no_selfchecks: { zh: '还没有 self-check 记录', en: 'No self-check records yet' },
  profile_view_result: { zh: '查看结果', en: 'View result' },
  profile_recent_logs: { zh: '最近的奶量记录', en: 'Recent milk logs' },
  profile_add_log: { zh: '添加奶量记录', en: 'Add milk log' },
  profile_start_new_check: { zh: '开始新的 Self-check', en: 'Start new self-check' },
  profile_send_summary: { zh: '发送到 WhatsApp', en: 'Send to WhatsApp' },

  // Self-check guest gate
  selfcheck_gate_title: { zh: '在开始前…', en: 'Before you start…' },
  selfcheck_gate_desc: {
    zh: '创建简单档案后，下次回来还能查看本次结果。',
    en: 'Create a simple profile so you can come back to this result later.',
  },
  selfcheck_gate_create: { zh: '创建档案再开始', en: 'Create profile, then start' },
  selfcheck_gate_guest: { zh: '以访客继续', en: 'Continue as guest' },
  selfcheck_guest_reminder: {
    zh: '提示：创建档案后下次还能找回这次结果。',
    en: 'Tip: create a profile if you want to view this result again later.',
  },
  nav_my: { zh: '我的', en: 'My Profile' },

  // Admin Mothers tab
  admin_tab_mothers: { zh: '妈妈档案', en: 'Mothers' },
  admin_mothers_empty: { zh: '暂无妈妈档案', en: 'No mother profiles yet' },

  // Landing
  landing_title: {
    zh: '现在的哺乳问题，先帮你判断一下',
    en: "Let's understand your breastfeeding concern first",
  },
  landing_subtitle: {
    zh: '回答几个问题，系统会根据你的情况给你初步建议、处理步骤和是否需要预约专业协助。',
    en: 'Answer a few guided questions and receive initial guidance, practical next steps, and whether professional lactation support may be helpful.',
  },
  landing_btn_start: { zh: '开始 Self-check', en: 'Start Self-check' },
  landing_btn_log: { zh: '记录今天奶量', en: 'Log Milk Today' },
  landing_btn_book: { zh: '预约咨询', en: 'Book Consultation' },
  landing_disclaimer: {
    zh: '本工具提供哺乳教育和初步分流，不取代医生诊断。如有发烧、红肿加剧、剧痛或宝宝精神差，请尽快就医。',
    en: 'This tool provides breastfeeding education and initial triage. It does not replace medical diagnosis. If you have fever, worsening redness, severe pain, or your baby seems unwell, please seek medical care.',
  },
  landing_features_title: { zh: '我们提供的支持', en: 'How we support you' },
  feature_selfcheck_title: { zh: '智能自我检测', en: 'Guided Self-check' },
  feature_selfcheck_desc: { zh: '根据你的回答给出初步分流和实用建议', en: 'Initial triage and practical guidance based on your answers' },
  feature_teaching_title: { zh: '免费教学资源', en: 'Free Teaching Resources' },
  feature_teaching_desc: { zh: '手挤奶、按摩、含乳姿势等实用教学', en: 'Hand expression, massage, latch positions and more' },
  feature_booking_title: { zh: '专业泌乳顾问', en: 'Verified Consultants' },
  feature_booking_desc: { zh: '视频咨询、上门服务、挤奶器配对', en: 'Video calls, home visits, pump fitting' },
  founder_title: { zh: '关于创办人', en: 'About the Founder' },
  founder_name: { zh: 'Soo Li Theng', en: 'Soo Li Theng' },
  founder_bio: {
    zh: '马来西亚华人注册护士，拥有 15 年护理经验、认证培训师与哺乳同伴顾问。自 2021 年起从事月子中心母婴照护，2023 年 6 月创办自己的泌乳服务公司。',
    en: 'Malaysian Chinese registered nurse with 15 years nursing experience, certified trainer and lactation peer counsellor. In confinement-centre mother-baby care since 2021, founded her own lactation service in June 2023.',
  },

  // Language
  lang_select_title: { zh: '请选择语言', en: 'Choose your language' },
  lang_zh: { zh: '中文', en: '中文' },
  lang_en: { zh: 'English', en: 'English' },
  lang_ms: { zh: 'Bahasa Malaysia - 即将推出', en: 'Bahasa Malaysia - Coming soon' },

  // Risk
  risk_green: { zh: '绿色 · 可自我处理', en: 'Green · Self-care' },
  risk_yellow: { zh: '黄色 · 建议关注', en: 'Yellow · Watch closely' },
  risk_red: { zh: '红色 · 需专业评估', en: 'Red · Seek professional care' },

  // Self-check progress
  step_profile: { zh: '基本资料', en: 'Profile' },
  step_redflag: { zh: '症状评估', en: 'Symptoms' },
  step_module: { zh: '问题详情', en: 'Details' },
  step_result: { zh: '初步结果', en: 'Result' },
  step_primary_concern: { zh: '主要问题', en: 'Primary concern' },
  step_related_concerns: { zh: '相关问题', en: 'Related concerns' },
  step_goal_confirm: { zh: '确认目标', en: 'Confirm goal' },

  // Concern picker
  q_primary_title: { zh: '你今天最想解决的主要问题是什么？', en: 'What is your main concern today?' },
  q_primary_hint: { zh: '请选择一个最优先的问题。', en: 'Pick the single most important issue.' },
  q_related_title: { zh: '还有其他相关的问题吗？（可选，最多 2 个）', en: 'Any related concerns? (optional, up to 2)' },
  q_related_hint: { zh: '我们会把所有结果整合在同一份报告里，无需重做。', en: 'We will combine everything into one report — no need to retake the quiz.' },
  q_related_cap: { zh: '已选择 {n}/2', en: 'Selected {n}/2' },
  q_already_primary: { zh: '已是主要问题', en: 'Already primary' },
  q_goal_conflict_note: {
    zh: '你同时选择了"奶量少"和"想退奶"。这两个方向不同，请先确认你目前的目标，我们才能给你最合适的建议。',
    en: 'You selected both "Low supply" and "Weaning". These goals point in opposite directions — please confirm which one matters most right now so we can tailor the advice.',
  },

  // Result page additions (combined view)
  result_primary_chip: { zh: '主要', en: 'Primary' },
  result_related_chip: { zh: '相关', en: 'Related' },
  result_helpful_tools: { zh: '可能有帮助的工具', en: 'Helpful tools' },
  result_goal_label: { zh: '你确认的目标', en: 'Your confirmed goal' },
  result_combined_summary_title: { zh: '综合分析与处理顺序', en: 'Summary & Priority Plan' },
  result_priority_plan: { zh: '建议处理顺序', en: 'Suggested priority order' },
  q_followup_applies_to: { zh: '同时关于', en: 'also relevant to' },

  // Helpful tools (Phase 2 — partner products)
  helpful_tools_title: { zh: '实用工具', en: 'Helpful tools' },
  helpful_tools_disclosure: {
    zh: '以下工具可能对你的情况有帮助。部分产品可能是合作品牌或含有折扣链接；是否适合仍要看你的实际情况，不确定可以先 WhatsApp 顾问确认。',
    en: 'These tools may be helpful for your situation. Some items may be partner products or include discount links. Suitability depends on your condition; if unsure, WhatsApp our consultant first.',
  },
  helpful_copy: { zh: '复制', en: 'Copy' },
  helpful_copied: { zh: '已复制', en: 'Copied' },
  helpful_code_copied: { zh: '折扣码已复制', en: 'Discount code copied' },
  helpful_copy_manual: { zh: '无法自动复制，请长按折扣码复制', en: 'Automatic copy is unavailable. Press and hold the code to copy.' },
  helpful_copy_manual_hint: { zh: '请长按上方折扣码 → 复制', en: 'Long-press the code above → Copy' },

  // Result page
  result_likely: { zh: '你目前的情况', en: 'Your current situation' },
  result_why: { zh: '为什么会这样', en: 'Why this may happen' },
  result_what_to_do: { zh: '现在可以这样做', en: 'What to do now' },
  result_observe: { zh: '接下来 24 小时观察', en: 'Watch for next 24 hours' },
  result_when_doctor: { zh: '何时需要看医生', en: 'When to see a doctor' },
  result_teaching: { zh: '免费教学资源', en: 'Free teaching resources' },
  result_disclaimer: {
    zh: '此结果根据你的回答提供初步建议，并非正式诊断。如有疑虑请咨询医师。',
    en: 'Based on your answers, this is initial guidance — not a formal diagnosis. Please seek medical advice if concerned.',
  },
  result_send_whatsapp: { zh: '发送总结到 WhatsApp', en: 'Send summary on WhatsApp' },
  result_book: { zh: '预约咨询', en: 'Book consultation' },
  result_choose_consultant: { zh: '选择顾问', en: 'Choose consultant' },
  result_start_log: { zh: '开始记录奶量', en: 'Start milk log' },
  result_when_seek_medical: { zh: '什么时候需要就医（安全提示）', en: 'When to seek medical care (safety note)' },
  result_extra_cta_pump_fit: { zh: '预约挤奶器/喇叭尺寸咨询', en: 'Book pump fitting consultation' },
  result_extra_cta_one_month: { zh: '一对一陪跑（一个月）', en: 'One-month breastfeeding coaching' },
  result_extra_cta_home_visit: { zh: '预约上门服务', en: 'Book home visit' },
  result_extra_cta_video_latch: { zh: '预约视频含乳指导', en: 'Book video latch coaching' },
  result_extra_cta_in_person_latch: { zh: '预约线下含乳评估', en: 'Book in-person latch assessment' },
  result_extra_cta_work_plan: { zh: '回职场挤奶规划咨询', en: 'Return-to-work pumping consultation' },
  result_extra_cta_wean_plan: { zh: '预约退奶/减奶咨询', en: 'Book weaning consultation' },

  // WhatsApp
  whatsapp_title: { zh: 'WhatsApp 总结', en: 'WhatsApp Summary' },
  whatsapp_subtitle: { zh: '点击下方按钮把这份总结发送给 Soo', en: 'Tap below to send this summary to Soo' },
  whatsapp_open: { zh: '在 WhatsApp 中打开', en: 'Open in WhatsApp' },
  whatsapp_copy: { zh: '复制总结', en: 'Copy summary' },
  whatsapp_copied: { zh: '已复制', en: 'Copied' },

  // Booking
  booking_title: { zh: '预约咨询', en: 'Book a Service' },
  booking_subtitle: { zh: '选择最适合你的服务', en: 'Choose the service that fits you best' },
  booking_book_btn: { zh: '通过 WhatsApp 预约', en: 'Book via WhatsApp' },
  service_videocall: { zh: '视频咨询', en: 'Video Call Consultation' },
  service_videocall_desc: { zh: '适合：亲喂姿势、泵奶设置、轻中度问题', en: 'Best for latch positioning, pump settings, and mild-to-moderate concerns.' },
  service_homevisit: { zh: '上门无痛通乳', en: 'Home Visit Painless Lactation' },
  service_homevisit_desc: { zh: '适合：堵奶、涨奶严重、小白点合并硬块、反复堵奶', en: 'Best for clogged ducts, severe engorgement, milk bleb with lump, recurring blockage.' },
  service_pump: { zh: '挤奶器配对咨询', en: 'Pump Fitting Consultation' },
  service_pump_desc: { zh: '适合：乳头痛、喇叭尺寸不合、挤奶器选择', en: 'Best for nipple pain, flange sizing, pump selection.' },
  service_coaching: { zh: '一个月哺乳陪跑', en: 'One-month Breastfeeding Coaching' },
  service_coaching_desc: { zh: '适合：奶量焦虑、回职场、反复堵奶、想稳定哺乳', en: 'Best for milk supply anxiety, returning to work, recurring clogged ducts, ongoing support.' },

  // Consultants
  consultants_title: { zh: '选择泌乳顾问', en: 'Choose a Consultant' },
  consultants_subtitle: { zh: '选择一位顾问，或让平台为你安排', en: 'Pick a consultant or let the platform assign one' },
  consultant_choose_soo: { zh: '指定 Soo', en: 'Choose Soo' },
  consultant_let_platform: { zh: '由平台帮我安排最快顾问', en: 'Let platform assign fastest available' },
  consultant_let_soo_review: { zh: '让 Soo 先筛选', en: 'Let Soo review first' },
  consultant_choose_this: { zh: '指定这位顾问', en: 'Choose this consultant' },
  consultant_view: { zh: '查看资料', en: 'View profile' },
  consultant_specialties: { zh: '专长', en: 'Specialties' },
  consultant_areas: { zh: '服务范围', en: 'Service Areas' },
  consultant_languages: { zh: '语言', en: 'Languages' },
  consultant_cases: { zh: '案例', en: 'Cases' },
  consultant_rating: { zh: '评分', en: 'Rating' },

  // Milk Log
  milklog_title: { zh: '奶量记录', en: 'Milk Log' },
  milklog_today_total: { zh: '今日总奶量', en: 'Today total' },
  milklog_sessions: { zh: '今日次数', en: 'Sessions today' },
  milklog_left_vs_right: { zh: '左 vs 右', en: 'Left vs Right' },
  milklog_add: { zh: '新增记录', en: 'Add Record' },
  milklog_method: { zh: '方式', en: 'Method' },
  milklog_method_latch: { zh: '亲喂', en: 'Direct latch' },
  milklog_method_pump: { zh: '挤奶器', en: 'Pump' },
  milklog_method_hand: { zh: '手挤', en: 'Hand express' },
  milklog_left_ml: { zh: '左侧 (ml)', en: 'Left (ml)' },
  milklog_right_ml: { zh: '右侧 (ml)', en: 'Right (ml)' },
  milklog_duration: { zh: '时长（分钟）', en: 'Duration (min)' },
  milklog_pain: { zh: '疼痛分数 (0-10)', en: 'Pain score (0-10)' },
  milklog_lump: { zh: '是否有硬块', en: 'Lump?' },
  milklog_fever: { zh: '是否发烧', en: 'Fever?' },
  milklog_diapers: { zh: '尿布次数', en: 'Wet diapers' },
  milklog_notes: { zh: '备注', en: 'Notes' },
  milklog_no_records: { zh: '还没有记录，开始添加吧', en: 'No records yet — add your first one' },
  milklog_reminder: {
    zh: '不要只看一次奶量，看 3 天趋势比较准确。',
    en: 'Do not judge supply from one session. Look at a 3-day trend.',
  },
  milklog_delete: { zh: '删除', en: 'Delete' },

  // Admin
  admin_title: { zh: '管理后台', en: 'Admin Dashboard' },
  admin_login_title: { zh: '管理员登录', en: 'Admin Login' },
  admin_password: { zh: '密码', en: 'Password' },
  admin_login_btn: { zh: '登录', en: 'Login' },
  admin_logout: { zh: '退出', en: 'Logout' },
  admin_no_cases: { zh: '暂无案例', en: 'No cases yet' },
  admin_assign: { zh: '分配给', en: 'Assign to' },
  admin_status: { zh: '状态', en: 'Status' },
  admin_unassigned: { zh: '未分配', en: 'Unassigned' },

  // Status
  status_new_lead: { zh: '新案例', en: 'New lead' },
  status_pending_review: { zh: '待审核', en: 'Pending review' },
  status_pending_assignment: { zh: '待分配', en: 'Pending assignment' },
  status_assigned: { zh: '已分配', en: 'Assigned' },
  status_consultant_accepted: { zh: '顾问已接受', en: 'Consultant accepted' },
  status_customer_contacted: { zh: '已联系客户', en: 'Customer contacted' },
  status_consultation_scheduled: { zh: '已排期', en: 'Consultation scheduled' },
  status_service_completed: { zh: '已完成', en: 'Service completed' },
  status_reassigned: { zh: '已重新分配', en: 'Reassigned' },
  status_closed: { zh: '已关闭', en: 'Closed' },

  // Admin case detail drawer
  admin_case_detail: { zh: '案例详情', en: 'Case Detail' },
  admin_close: { zh: '关闭', en: 'Close' },
  admin_section_profile: { zh: '基本资料', en: 'Basic Profile' },
  admin_section_redflag: { zh: '红旗症状', en: 'Red-Flag Answers' },
  admin_section_module: { zh: '问题详情', en: 'Module Answers' },
  admin_section_result: { zh: '结果摘要', en: 'Result Summary' },
  admin_section_history: { zh: '案例历史', en: 'Assignment History' },
  admin_section_notes: { zh: '内部备注（仅管理员可见）', en: 'Admin Notes (admin only)' },
  admin_section_milk: { zh: '近期奶量记录', en: 'Recent Milk Logs' },
  admin_section_whatsapp: { zh: 'WhatsApp 总结', en: 'WhatsApp Summary' },
  admin_field_risk: { zh: '风险等级', en: 'Risk level' },
  admin_field_result_type: { zh: '结果类型', en: 'Result type' },
  admin_field_pref_service: { zh: '客户首选服务', en: 'Preferred service' },
  admin_field_pref_consultant: { zh: '客户首选顾问', en: 'Preferred consultant' },
  admin_field_created: { zh: '提交时间', en: 'Created at' },
  admin_save_notes: { zh: '保存备注', en: 'Save notes' },
  admin_notes_placeholder: { zh: '在此输入内部备注...', en: 'Type internal notes here...' },
  admin_copy_summary: { zh: '复制 WhatsApp 总结', en: 'Copy WhatsApp summary' },
  admin_open_whatsapp: { zh: '在 WhatsApp 中打开', en: 'Open in WhatsApp' },
  admin_history_created: { zh: '案例创建', en: 'Case created' },
  admin_history_assignment: { zh: '分配顾问', en: 'Consultant assigned' },
  admin_history_reassignment: { zh: '重新分配顾问', en: 'Consultant reassigned' },
  admin_history_status: { zh: '状态变更', en: 'Status changed' },
  admin_history_empty: { zh: '暂无历史记录', en: 'No history yet' },
  admin_milk_disclaimer: {
    zh: '奶量记录目前未与个别妈妈关联，下方仅显示系统近期 5 笔记录。',
    en: 'Milk logs are not yet linked to individual mothers — showing 5 most recent system entries.',
  },
  admin_no_milk: { zh: '暂无奶量记录', en: 'No milk logs yet' },
  admin_unassigned_short: { zh: '未分配', en: 'Unassigned' },

  // Teaching
  teaching_title: { zh: '免费教学资源', en: 'Free Teaching Resources' },
  teaching_back: { zh: '返回', en: 'Back' },
  teaching_use_for: { zh: '适用于', en: 'Use for' },
};

export const t = (key, lang) => {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry.en || key;
};
